import { Link } from 'react-router-dom';
import Enums from '../../utilities/enum';
import { useState } from 'react';

export const DevicesStatusTable = (props) => {
    const [modalId, setModalId] = useState(null)
    const [lastReadCamera, setLastReadCamera] = useState(null)
    return (
        <tbody>
            {
                props.filteredDevices?.map(item => {
                    const url = '/organisation/' + props.organisationId + '/site/' + item?.filteredDevice?.siteId + '/camera/' + item?.filteredDevice?.id
                    const deviceName = <h6 className="mb-0">{ item?.filteredDevice?.name }</h6>

                    return (
                        <tr key={ item?.filteredDevice?.id }>
                            {
                                props.deviceType === Enums.DeviceType[0] &&
                                <td className="align-middle pr-4" style={ { width: "1%" } }>
                                    {
                                        item?.filteredDevice?.imageUrl
                                            ? <button
                                                onClick={ () => setLastReadCamera(item?.filteredDevice) }
                                                className="btn btn-none p-0 m-0 d-block"
                                                type="button"
                                                data-toggle="modal"
                                                data-target="#last-read-modal"
                                                title="View last read image">
                                                <img src={ item.filteredDevice.imageUrl } alt="Last camera read" loading="lazy" className="rounded" style={ { width: "80px", height: "45px", objectFit: "cover" } } />
                                            </button>
                                            : <div className="d-flex align-items-center justify-content-center rounded bg-200 text-500" style={ { width: "80px", height: "45px" } }>
                                                <i className="fas fa-camera"></i>
                                            </div>
                                    }
                                </td>
                            }
                            <td className="align-middle">
                                {
                                    props.deviceType === Enums.DeviceType[0]
                                        ? (<Link to={ url }>{ deviceName }</Link>)
                                        : (deviceName)
                                }
                            </td>
                            <td className="align-middle">{ item?.filteredDevice?.siteName }</td>
                            {
                                props.deviceType === Enums.DeviceType[0] &&
                                <td className="text-center align-middle">
                                    {
                                        item?.filteredDevice?.isActive
                                            ? <i className="fas fa-check text-success"></i>
                                            : <i className="fas fa-times text-danger"></i>
                                    }
                                </td>
                            }
                            <td className="text-center heartbeat align-middle">
                                { item?.pillButton }
                            </td>
                            {
                                props.deviceType === "Kiosk" && props.viewAll &&
                                <td className="text-right align-middle">
                                    <button
                                        onClick={ () => setModalId(item?.filteredDevice?.id) }
                                        className="btn btn-default border btn-sm ml-1"
                                        data-toggle="modal"
                                        data-target="#delete-modal">
                                        <i class="fas fa-trash-alt mr-2"></i>Delete
                                    </button>
                                </td>
                            }
                        </tr>
                    )
                })
            }

            {
                props.deviceType === Enums.DeviceType[0] &&
                <div className="modal fade" id="last-read-modal" tabIndex="-1" role="dialog" aria-labelledby="lastReadModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="lastReadModalLabel">{ lastReadCamera?.name } - Last Image</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                { lastReadCamera?.imageUrl && <img width="100%" src={ lastReadCamera.imageUrl } alt="Last camera read" /> }
                            </div>
                        </div>
                    </div>
                </div>
            }

            {
                modalId && <>
                    <div className="modal fade" id="delete-modal" tabIndex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="deleteModalLabel">Are you sure you want to delete this Kiosk?</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                                    <button type="button" className="btn btn-danger btn-sm ml-2" data-dismiss="modal" onClick={ () => props.handleDelete(modalId) }>
                                        Delete</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </tbody>
    )

}